export default "__VITE_ASSET__6d63ea58__"